<!-- Footer Start -->
<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4">
        {{ year }} © Powered by
        <a target="_blank" href="https://www.leetrans.com">Lee Trans</a>
      </div>
      <div class="col-md-4 text-center">
        <a href="#" (click)="openHelpModal($event)">Need Help?</a>
      </div>
      <div class="col-md-4">
        <!-- <div class="text-md-right footer-links">
                    <a routerLink="/privacy-policy">Privacy Policy</a>
                </div> -->
      </div>
    </div>
  </div>
</footer>
<!-- end Footer -->
